<template>
  <responsive-controller>
    <template #tablet>
      <project-dashboard-mobile-template
        :project="PROJECT_INFO"
        :graph="GRAPH"
      ></project-dashboard-mobile-template>
    </template>
    <template #default>
      <project-dashboard-desktop-template
        :project="PROJECT_INFO"
        :graph="GRAPH"
      ></project-dashboard-desktop-template>
    </template>
  </responsive-controller>
</template>

<script>
import { mapState } from 'vuex';

import ProjectDashboardMobileTemplate from 'templates/project/mobile/ProjectDashboardMobileTemplate';
import ProjectDashboardDesktopTemplate from 'templates/project/desktop/ProjectDashboardDesktopTemplate';

export default {
  name: 'ProjectDashboard',
  components: {
    ProjectDashboardMobileTemplate,
    ProjectDashboardDesktopTemplate,
  },
  computed: {
    ...mapState([
      'PROJECT_INFO',
      'GRAPH',
    ]),
  },
};
</script>
